import { render, staticRenderFns } from "./ReceiptList.vue?vue&type=template&id=2a4ebfdf"
import script from "./ReceiptList.vue?vue&type=script&lang=js"
export * from "./ReceiptList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports